import gql from 'graphql-tag';

export const GET_USER = gql`
  query GetUser($id: ID!) {
    User(id: $id) {
      id
      name
      email
      phone
      address
      city
      zip
      orgNumber
      invoiceType
      createdAt
      tokens {
        id
        createdAt
        offer {
          id
          nameLang {
            id
            en
            es
            no
            se
          }
        }
      }
      stampCards {
        id
        nameLang {
          id
          en
          es
          no
          se
        }
        count
      }
      stamps {
        id
        createdAt
        stampCard {
          id
        }
      }
      membershipLevel {
        id
        primaryColor
        discountPercentage
        title {
          id
          en
          es
          no
          se
        }
      }
      membershipCard {
        id
        points
        membershipLevel {
          id
          primaryColor
          discountPercentage
          title {
            id
            en
            es
            no
            se
          }
        }
        transactions(orderBy: createdAt_DESC, first: 20) {
          id
          amount
          source
          createdAt
        }
      }
      orders {
        id
        createdAt
        status
        payment {
          id
          amount
          tip
          correctedTip
        }
      }
      _ordersMeta(filter: { status_in: [COMPLETED, REJECTED, REFUNDED] }) {
        count
      }
      segments(filter: { deleted: false }) {
        id
        name
      }
    }
  }
`;

export const MEMBERS_QUERY = gql`
  query AllUsers($filter: UserWhereInput, $skip: Int, $first: Int, $orderBy: UserOrderByInput) {
    allUsers(filter: $filter, skip: $skip, first: $first, orderBy: $orderBy) {
      id
      role
      venues {
        id
      }
      email
      name
      phone
      createdAt
      membershipCard {
        id
        points
        membershipLevel {
          id
          primaryColor
          title {
            id
            en
            es
            no
            se
          }
        }
      }
      membershipLevel {
        id
        primaryColor
        title {
          id
          en
          es
          no
          se
        }
      }
    }
  }
`;
